var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vm-markdown-html"},[(_vm.value != '')?_c('pre',[_vm._v(_vm._s(_vm.value))]):_c('div',{staticClass:"md-loading"},[_c('span',{staticClass:"md-spinner"}),_vm._v(" Yükleniyor... ")])])}
var staticRenderFns = []

export { render, staticRenderFns }